<template>
  <div class="notice-card">
    <div class="notice-content">
      <p class="title" v-markdown="attributes.value.title" />
      <p v-markdown="attributes.value.content" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["attributes"],
};
</script>

<style lang="scss">
.notice-card {
  background-color: $screen;

  .notice-content {
    padding: 29px;

    .title {
      margin-bottom: 12px;
    }

    p {
      font-size: 16px;
      line-height: 22px;
      font-family: $font-CuratorRegular;

      strong {
        font-family: $font-CuratorBold;
      }
    }
  }
}
</style>
